import { AutogenModelContactLookup, AutogenRowContactLookup } from "./autogen/AutogenModelContactLookup";

export class ModelContactLookup extends AutogenModelContactLookup<RowContactLookup> {
	constructor() {
		super(RowContactLookup);
	}
}

export class RowContactLookup extends AutogenRowContactLookup {
}